import { string, bool } from 'prop-types';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { Suspense } from 'react';
import PreviouslyAssignedSkeleton from '../../components/shared/PreviouslyAssignedSkeleton/PreviouslyAssignedSkeleton';
import PreviouslyAssignedContent from '../shared/PreviouslyAssignedContent';
import programTypes from '../../scripts/constants';

const OTPreviouslyAssignedPage = ({
	apiEnv,
	ssId,
	pathToActionPlanRoutes,
	memberId,
	isAdmin,
}) => (
	<Box component="section">
		<Button
			onClick={() => window.history.back()}
			startIcon={<ChevronLeftIcon />}
			data-testid = "back-button"
		>
			Back
		</Button>
		<Typography
			textAlign="center"
			variant="h5"
			component="h1"
			gutterBottom
			pt={5}
			pb={8}
			data-testid = "previously-assigned-title"
		>
			Previously assigned exercises
		</Typography>
		<Suspense fallback={<PreviouslyAssignedSkeleton />}>
			<PreviouslyAssignedContent
				apiEnv={apiEnv}
				ssId={ssId}
				memberId={memberId}
				isAdmin={isAdmin}
				pathToActionPlanRoutes={pathToActionPlanRoutes}
				programType={programTypes.occupationalTherapy}
			/>
		</Suspense>
	</Box>
);

OTPreviouslyAssignedPage.propTypes = {
	/*
	 * The environment the component is being hosted on such as "prod" or "dev".
	 */
	apiEnv: string.isRequired,
	/*
	 * Session ID to be added to the header when calling the API.
	 */
	ssId: string.isRequired,
	/*
	 * pathToActionPlanRoutes: string that leads to where action plan routes are mounted. Eg. if you mounted actionPlanRoutes at `/actionPlan`, you would pass "/actionPlan"
	 */
	pathToActionPlanRoutes: string,
	/*
	 * Member ID to be added to the header when calling the API.
	 */
	memberId: string,
	/*
	 * Flag to indicate to the component if the consumer is an admin site
	 */
	isAdmin: bool,
};

OTPreviouslyAssignedPage.defaultProps = {
	pathToActionPlanRoutes: '',
	isAdmin: false,
	memberId: '',
};

export default OTPreviouslyAssignedPage;
